// Simple debug bus for collecting and streaming debug events across the app
export type DebugLevel = 'info' | 'warn' | 'error' | 'event'

export interface DebugLogEntry {
  id: number
  ts: number
  level: DebugLevel
  source: string
  message: string
  payload?: any
}

let counter = 0
const logs: DebugLogEntry[] = []
const subscribers: Array<(entry: DebugLogEntry) => void> = []

export function addDebugLog(entry: Omit<DebugLogEntry, 'id' | 'ts'>) {
  const full: DebugLogEntry = {
    id: ++counter,
    ts: Date.now(),
    ...entry,
  }
  logs.push(full)
  // Keep a reasonable cap
  if (logs.length > 500) logs.shift()
  subscribers.forEach(cb => {
    try { cb(full) } catch { /* noop */ }
  })
}

export function logInfo(source: string, message: string, payload?: any) {
  addDebugLog({ level: 'info', source, message, payload })
}

export function logWarn(source: string, message: string, payload?: any) {
  addDebugLog({ level: 'warn', source, message, payload })
}

export function logError(source: string, message: string, payload?: any) {
  addDebugLog({ level: 'error', source, message, payload })
}

export function logEvent(source: string, type: string, payload?: any) {
  addDebugLog({ level: 'event', source, message: type, payload })
}

export function getDebugLogs(): DebugLogEntry[] {
  return logs.slice()
}

export function clearDebugLogs() {
  logs.splice(0, logs.length)
}

export function subscribeDebug(cb: (entry: DebugLogEntry) => void) {
  subscribers.push(cb)
  return () => {
    const idx = subscribers.indexOf(cb)
    if (idx >= 0) subscribers.splice(idx, 1)
  }
}

